import { makeStyles } from '@fluentui/react-components';

export const useEnvironmentBadgeStyles = makeStyles({
  trigger: {
    minWidth: 0,
    height: 'auto',
    padding: 0,
  },
  badge: {
    flexShrink: 0,
    textTransform: 'uppercase',
  },
  versions: {
    display: 'flex',
    flexDirection: 'column',
  },
});
